module.exports = __webpack_public_path__ + "static/media/landing2.28f59bd6.svg";